export default __webpack_public_path__ + "src/images/light-2a6be7.png";